import React, { useState, useEffect } from 'react';
import ChatBot from "react-chatbotify";
import axios from "axios";


const index_name = "aircraft_handbook";

const SourceButton = () => {
  const openHandbook = () => {
    window.open(
      "https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/airplane_handbook",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <button onClick={openHandbook}
    style={{
        backgroundColor: "#7518b9", // React ChatBotify primary color
        color: "#fff",
        border: "none",
        borderRadius: "15px",
        padding: "10px",
        margin: "10px 0px 0px 50px",
        fontWeight: 500,
        fontWeight: "bold",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
      onMouseOver={(e) => (e.target.style.backgroundColor = "#750099")}
      onMouseOut={(e) => (e.target.style.backgroundColor = "#7518b9")}
      >
      🔗 Navigate to Source Doc
    </button>
  );
};

const extractName = (text) => {
  const patterns = [
    /I am (\w+)/i,
    /My name is (\w+)/i,
    /I'm (\w+)/i,
    /call me (\w+)/i,                     // "Call me John"
    /name's (\w+)/i,                      // "name's John"
    /its (\w+)/i,                         // "its John"
    /it's (\w+)/i,                        // "it's John"
    /this is (\w+)/i,                     // "This is John"
  ];

  for (let pattern of patterns) {
    const match = text.match(pattern);
    if (match) return match[1];
  }
  return null;
};

const PMChatBot = () => {

  const [chatuser, setChatuser] = useState(null);

	// necessary to embed the chatbot for it to show on the page
	const settings = {
        isOpen: false,
        general: {
          primaryColor: '#42b0c5',
          secondaryColor: '#491d8d',
          fontFamily: 'Arial, sans-serif',
          embedded: false,
        },
        header: {
            title: "Vee Bot"
            //   // note: if features are disabled, their buttons will not show up even if specified here
            // buttons: [<button onClick={() => window.open("https://www.faa.gov/regulations_policies/handbooks_manuals/aviation/airplane_handbook", "_blank")}>Source Doc</button>]
        },
        footer:{ 
          text: ""
        },
        audio: {
          disabled: false,
        },
        // chatHistory: {
        //   storageKey: "concepts_settings"
        // },
        chatWindow: {
            defaultOpen: false
        },
        chatHistory: {
            disabled: false
          }
    }

    const flow = {
        start: {
            message: `Hi there! I am VeeBot.`,
            transition: 500,
            path: "welcomemsg"
        },
        welcomemsg: {
            message: "Welcome to the Knowledge Base RAG Chat Bot. 🥳!",
            transition: 500,
            path: "srcmsg"
        },
        srcmsg: {
            message: "I've been trained using the contents of the FAA Airplane Flying Handbook.",
            component: <SourceButton />,
            transition: 500,
            path: "usrmsg"
        },
        usrmsg: {
            message: `Feel free to ask any questions about the handbook, and I'll answer them using the information and context from the document.`,
            path: "question_loop"
        },
        question_loop: {
          message: async (params) => {
            const userQuestion = params.userInput;
            const userInput = userQuestion.toLowerCase();
        
            if (userInput === "exit" || userInput === "bye") {
              await params.injectMessage("Thanks for chatting! Have a nice day!");
              return;  // ✅ just return, path handles the rest
            }
        
            if (userInput === "help") {
              await params.injectMessage("You can ask me anything within the context of the FAA Airplane Flying Handbook.");
              return;  // ✅ just return
            }
        
            try {
              const response = await axios.post(
                "https://veeramanicadas-rag-be-app.hf.space/connect-llm",
                { query: userQuestion, store_id: index_name, k: 5, user: chatuser},
                { timeout: 60000, headers: { "Content-Type": "application/json" } }
              );
              await params.injectMessage(`Here's the response: ${response.data.answer}`);
            } catch (error) {
              if (error.code === "ECONNABORTED") {
                await params.injectMessage("The request timed out. Please send your question again.");
              } else if (error.response) {
                await params.injectMessage("Server error. Please try again later.");
              } else {
                await params.injectMessage("Network error. Please check your connection.");
              }
            }
          },
          path: async (params) => {
            const userInput = params.userInput.toLowerCase();
            // ✅ Dynamically route to end_loop on bye/exit
            if (userInput === "exit" || userInput === "bye") return "end_loop";
            return "question_loop";
          }
        },
        end_loop: {
          message: `Thank you for your time!  See You Soon! 👋`,
          chatDisabled: true
        }
      };

	const themes = [
        {id: "rosa", version: "0.1.0"}
	]

	return (
		<ChatBot themes={themes} flow={flow} settings={settings}/>
	);
};

export default PMChatBot;